import { render, staticRenderFns } from "./FormDualStreamRecordStreamax.vue?vue&type=template&id=b33ad5d4&scoped=true&"
import script from "./FormDualStreamRecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormDualStreamRecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormDualStreamRecordStreamax.vue?vue&type=style&index=0&id=b33ad5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33ad5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b33ad5d4', component.options)
    } else {
      api.reload('b33ad5d4', component.options)
    }
    module.hot.accept("./FormDualStreamRecordStreamax.vue?vue&type=template&id=b33ad5d4&scoped=true&", function () {
      api.rerender('b33ad5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Record/FormDualStreamRecordStreamax.vue"
export default component.exports